import type { ReactNode } from "react";

import { Button as AriaButton } from "react-aria-components";

import { CloseOutlineFilled } from "../../icons/close-outline-filled";

import styles from "./filter-container.module.css";

type FilterContainerProps = {
	children: ReactNode;
	onChange: (value: null | string) => void;
	selected: null | string;
};

/**
 * Container for the filter, it will show the children and a clear button if there is a selected value
 */
export function FilterContainer({ children, onChange, selected }: FilterContainerProps): ReactNode {
	return (
		<div className={styles.filter}>
			{children}
			{selected && (
				<AriaButton
					aria-label="Clear filter"
					className={styles.closeIcon}
					onPress={() => {
						return onChange(null);
					}}
				>
					<CloseOutlineFilled height={16} width={16} />
				</AriaButton>
			)}
		</div>
	);
}
